/**
 * User: Keith Author: Faris Date: 6/24/15 Time: 10:30 AM
 */

define('app/views/calendar',['require','./page','./calendar_list','text!../../../views/calendar.html'],function(require) {

	var Page = require('./page');
	var CalendarList = require('./calendar_list');
	var template = require('text!../../../views/calendar.html');

	return Page.extend({

		template : _.template(template),

		events : {
			'click .calendarMonths div' : 'onClickMonth',
			'click .prev' : 'onClickPrev',
			'click .next' : 'onClickNext'
		},

		initialize : function() {
			
		},

		transitionInComplete : function() {
		    // Make current date str
            var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];          
            var date = new Date();
            this.dateStr = date.getFullYear()+"-"+(date.getMonth()+1)+"-1";
            
            // Pass in current date
            var list = new CalendarList({date: this.dateStr});
            list.createMonthNav();
            
            // Make navigation
            this.makeMonthNav(list.monthNav);
            
            // Show
            $('#calendarList', this.$el).html(list.$el);
            
			// Reinit scrollbar			
			this.updateScrollbars();			
		},
		
		makeMonthNav: function(monthNav) {
			for(var i = 0; i<monthNav.length; i++) {
				var month = monthNav[i];
				var div = $('<div></div>');
				div.html(month.MONTH);
				div.attr('data-month', month.FULLDATE);
				$(".calendarMonths").append(div);
			}
			// Index of current month
			this.months = monthNav;
			this.monthIndex = 0;
			this.monthsTotal = monthNav.length;
			
			// Hide back arrow since this is the beginning
			$(".prev").hide();
			
			// Make first div selected
			$(".calendarMonths div:first-of-type").addClass("selected");
			
			// Show/hide next arrow
            if(this.monthIndex<this.monthsTotal-1 && this.monthIndex!=-1) {
                $(".next").show();
            } else {
                $(".next").hide();
            }
			
			// Show Nav
			$(".calendarNav").show();
		},

		onClickMonth : function(e) {
			var index = $(e.target).index();
			this.monthIndex = index;
			this.showCalendarList();
		},
		
		onClickPrev : function() {
			this.monthIndex--;
			if(this.monthIndex<0 ) { this.monthIndex = 0; }			
			this.showCalendarList();
		},
		
		onClickNext: function() {
			this.monthIndex++;
			if(this.monthIndex>this.monthsTotal) { this.monthIndex = this.monthsTotal-1; }
			this.showCalendarList();
		},
		
		showCalendarList: function() {
			// Show/hide prev arrow
			if(this.monthIndex>0) {
				$(".prev").show();
			} else {
				$(".prev").hide();
			}
			
			// Show/hide next arrow
			if(this.monthIndex<this.monthsTotal-1 && this.monthIndex!=-1) {
				$(".next").show();
			} else {
				$(".next").hide();
			}
			
			// Underline month
			$(".calendarMonths div").removeClass("selected");
			$(".calendarMonths div").eq(this.monthIndex).addClass('selected');
			
			// Scroll month nav
			var left = $(".calendarMonths div:first-of-type").width()*this.monthIndex;
			$(".calendarMonths").animate({left: "-"+left+"px"}, 750);
			
			// Get index we are on and the date
			var newDate = this.months[this.monthIndex].FULLDATE;
			
			
			// Get content and display it
			var list = new CalendarList({date: newDate});
			$('#calendarList', this.$el).html(list.$el);
			
			// Reinit scrollbar
			this.updateScrollbars();
		}
	});
});
